module.exports = __webpack_public_path__ + "sx.2ce155b8843c542882f1.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/sx.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/sx.svg
// module chunks = styles